import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import config from '../../config'
import {
  Link,
  Grade
} from '../../components'

const Styles = require('./TargetDateSeriesScorecardRow.css')

@CSSModules(Styles, {allowMultiple:true})
export default class TargetDateSeriesScorecardRow extends Component {
  static propTypes = {
    // three letters, fff/dff/gef/gff/pff/wff/tff
    iyvCode: PropTypes.string.isRequired,
    // the target date series object
    targetDateSeries: PropTypes.object.isRequired,
  }
  constructor(props) {
    super(props)
    const { iyvCode, targetDateSeries } = props

    const query = {
      fff: 'fossil',
      dff: 'deforestation',
      gef: 'gender-equality',
      gff: 'guns',
      pff: 'prison-industrial-complex',
      wff: 'military-weapons',
      tff: 'tobacco',
    }[iyvCode] || null

    const label = {
      fff: 'Fossil fuel',
      dff: 'Deforestation',
      gef: 'Gender equality',
      gff: 'Civilian firearms',
      pff: 'Prison industrial complex',
      wff: 'Military weapons',
      tff: 'Tobacco',
    }[iyvCode] || null

    const gradeField = {
      fff: 'grade_fossil',
      dff: 'grade_deforestation',
      gef: 'grade_gender_equality',
      gff: 'grade_guns',
      pff: 'grade_prison_industrial_complex',
      wff: 'grade_military',
      tff: 'grade_tobacco'
    }[iyvCode] || null

    this.state = {
      iyvCode,
      targetDateSeries,
      query,
      label,
      gradeAsInt: targetDateSeries[gradeField] || null
    }
  }

  render() {
    const { iyvCode, targetDateSeries, query, label, gradeAsInt } = this.state

    const icon = {
      fff: require( '../../../static/images/icons/fff-icon.svg' ),
      dff: require( '../../../static/images/icons/dff-icon.svg' ),
      gef: require( '../../../static/images/icons/gef-icon.svg' ),
      gff: require( '../../../static/images/icons/gff-icon.svg' ),
      pff: require( '../../../static/images/icons/pff-icon.svg' ),
      wff: require( '../../../static/images/icons/wff-icon.svg' ),
      tff: require( '../../../static/images/icons/tff-icon.svg' )
    }[iyvCode] || null

    if (!query || !label || !icon || !gradeAsInt) { return null }

    //
    return (
      <div>
        <Link
          to={
            config.routes.targetDateFunds + '/' +
              targetDateSeries.strategy_name_query + '?issue=' + query
          }
          title={targetDateSeries.strategy_name}
        >
          <div styleName='scorecard-header-grade-flex'>
            <div styleName='icon-label-flex'>
              <div styleName='result-lbl-icon-bbl'>
                <img
                  styleName='result-lbl-icon'
                  src={icon}
                  alt={label + 'grade'}
                />
              </div>
              <div styleName='scorecard-header-grade-label'>
                {label} grade
              </div>
            </div>
            <div styleName={'scorecard-header-grade grade-'+gradeAsInt}>
              <Grade grade={gradeAsInt} square/>
            </div>
          </div>
        </Link>
      </div>
    )
  }
}